import { Container, Label, FormGroup, Input } from "reactstrap";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
// import TextErrors from '../../share/TextErrors'
import "../../share/form.css";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { NumberWithCommas } from "../../share/NumberWithCommas";
import Swal from 'sweetalert2'
// import { bahttext } from "bahttext"


export function OperationReportForm31Component() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const supportId = searchParams.get("req")
    // console.log(supportId)
    const [data, setData] = useState([]);

    console.log("data", data)
    useEffect(() => {
        const getData = async () => {
            try {
                let res = await fetch(`api/Support/getSupportOperationData/${supportId}`)
                const resJson = await res.json()
                setData(resJson.dataenum);
            } catch (err) {
                console.log("err", err)
            }
        }
        getData();
    }, [supportId])


    const initialValues = {
        supportId: supportId,
        supportRemark: "",
        benefitRemark: "",
        supportCheckbox: [],
        benefitCheckbox: [],
        issue: "",
        remark: "",
    };

    // console.log(bahttext(8.00))

    const onSubmit = async (values) => {
        if (values.supportCheckbox.length === 0 || values.benefitCheckbox.length === 0) {
            Swal.fire({
                icon: "warning",
                title: "กรุณาเลือกอย่างน้อย 1 ข้อ",
                text: "",
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            });
            return;
        } else {
            try {
                let res = await fetch("/api/Support/saveSupportOperation", {
                    method: "POST",
                    headers: { "Content-type": "application/json" },
                    body: JSON.stringify(values)
                });

                let resJson = await res.json();

                if (resJson.status === 1) {
                    Swal.fire({
                        icon: "success",
                        title: "บันทึกข้อมูลสำเร็จ",
                        text: "",
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    }).then((result) => {
                        navigate("/supporting")
                    })
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "บันทึกข้อมูลไม่สำเร็จ",
                        text: `เนื่องจาก ${resJson.message}`,
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    });
                }
            } catch (e) {
                console.log(e)
            }
        }

    }

    const validationSchema = Yup.object().shape({
        // casecheckbox:Yup.array().min(1,"กรุณาเลือกอย่างน้อย 1 ข้อ"),
        // benefitCheckbox:Yup.array().min(1,"กรุณาเลือกอย่างน้อย 1 ข้อ"),
        supportRemark: Yup.string()
    })


    return (
        <Container className="d-flex justify-content-center align-items-center mt-2 mb-4 tab-container">
            <div className="form-border">
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                >
                    {({ setFieldValue, values, touched, errors, isValid, dirty, handleBlur, handleChange }) => {
                        console.log("values", values)
                        return (
                            <Form className="p-5 mb-4">
                                {data?.map((item, i) => (
                                    <div className="mt-3">
                                        <Label>ชื่อผู้ได้รับเงินช่วยเหลือหรืออุดหนุน</Label>
                                        <p className="w-100 rounded-pill border text-primary p-1 text-center">{item.supportName}</p>
                                        <div className="mt-3 d-flex justify-content-betwenn align-items-center w-100">
                                            <div className="w-50 p-1">
                                                <Label className="form-Label">เลขที่คำขอ</Label>
                                                {item.supportNo !== null ? (
                                                    <p className="w-100 rounded-pill border text-primary p-1 text-center">{item.supportNo}</p>
                                                ) : (
                                                    <p className="w-100 rounded-pill border text-primary p-1 text-center">-</p>
                                                )}
                                            </div>
                                            <div className="w-50 p-1">
                                                <Label className="form-Label">ลงวันที่</Label>
                                                <p className="w-100 rounded-pill border text-primary p-1 text-center">{item.approveDate}</p>
                                            </div>
                                        </div>

                                        <Label className="form-Label">ได้รับเงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน (หน่วยงานที่อนุมัติคำขอ)</Label>
                                        <p className="w-100 rounded-pill border text-primary p-1 text-center">{item.deptName}</p>

                                        <Label className="form-Label">เป็นจำนวนเงิน</Label>
                                        <p className="w-100 rounded-pill border text-primary p-1 text-center">{NumberWithCommas(item.amount)} บาท</p>
                                    </div>
                                ))}

                                {/* checkbox 2 */}
                                <FormGroup className="mt-5">

                                    <p className="input-color">นำเงินช่วยเหลือหรืออุดหนุนที่ได้รับจากกองทุนพัฒนาฝีมือแรงงานไปส่งเสริมการพัฒนาฝีมือแรงงาน ดังนี้</p>
                                    <div className="form-check">
                                        <Field type="checkbox" name="supportCheckbox" value="01" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label className="form-check-Label " >
                                            เป็นค่าใช้จ่ายในการปรับปรุงอาคาร สถานที่ เครื่องมือ เครื่องจักร
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="supportCheckbox" value="02" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label className="form-check-Label " >
                                            เป็นค่าใช้จ่ายในการดำเนินการทดสอบมาตรฐานฝีมือแรงงาน เช่น ค่าวัสดุ ค่าตอบแทนผู้ทดสอบ เป็นต้น
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="supportCheckbox" value="03" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label className="form-check-Label " >
                                            เป็นค่าใช้จ่ายในการดำเนินการจัดฝึกอบรมฝีมือแรงงานให้แก่ลูกจ้าง
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="supportCheckbox" value="04" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label className="form-check-Label " >
                                            เป็นค่าใช้จ่ายในการส่งลูกจ้างเข้ารับการประเมินความรู้ความสามารถ
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="supportCheckbox" value="05" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label className="form-check-Label " >
                                            เป็นค่าใช้จ่ายในการจัดทำมาตรฐานฝีมือแรงงานของตนตามมาตรา 26 เพิ่มเติม
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="supportCheckbox" value="06" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label className="form-check-Label ">
                                            อื่นๆ (โปรดระบุ)
                                        </Label>
                                        <Field
                                            name="supportRemark"
                                            className="rounded-pill"
                                        >
                                            {({ field, form, meta }) => (
                                                <Input
                                                    type="text"
                                                    className="rounded-pill"
                                                    {...field}
                                                />

                                            )}
                                        </Field>
                                    </div>
                                </FormGroup>

                                {/* checkbox 3 */}
                                <FormGroup className="mt-4">
                                    <p className="input-color">ประโยชน์ที่ได้รับจากการดำเนินการพัฒนาฝีมือแรงงานให้แก่ลูกจ้าง</p>
                                    <div className="form-check">
                                        <Field type="checkbox" name="benefitCheckbox" value="01" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label class="form-check-Label ">
                                            สามารถยกระดับฝีมือแรงงานจากการพัฒนาฝีมือแรงงานให้แก่ลูกจ้าง
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="benefitCheckbox" value="02" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label class="form-check-Label ">
                                            สามารถกำหนดระดับความสามารถของพนักงานได้จากมาตรฐานฝีมือแรงงาน
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="benefitCheckbox" value="03" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label class="form-check-Label " >
                                            สามารถวางแผนพัฒนาบุคลากรหรือคัดเลือกบุคลากรที่เป็นช่างฝีมือเข้าทำงานได้เหมาะสมกับตำแหน่ง
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="benefitCheckbox" value="04" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label class="form-check-Label ">
                                            สามารถใช้เป็นแนวทางกำหนดอัตราค่าจ้างในกิจการ
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="benefitCheckbox" value="05" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label class="form-check-Label ">
                                            สามารถใช้ประกอบการพิจารณาเลื่อนตำแหน่งของพนักงาน
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="benefitCheckbox" value="06" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label class="form-check-Label ">
                                            สามารถเพิ่มรายได้ให้แก่พนักงานและกิจการ
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="benefitCheckbox" value="07" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label class="form-check-Label ">
                                            สามารถนำความรู้มาสร้างสรรค์นวัตกรรม เพื่อใช้ในการผลิตสินค้าหรือบริการ
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="benefitCheckbox" value="08" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label class="form-check-Label ">
                                            สามารถนำความรู้มาใช้กับเทคโนโลยีในการผลิตสินค้าหรือบริการ
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="benefitCheckbox" value="09" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label class="form-check-Label ">
                                            สามารถลดการสูญเสียวัสดุ อุปกรณ์ ที่เกิดจากการปฏิบัติงานที่ไม่ถูกต้อง
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="benefitCheckbox" value="10" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label class="form-check-Label ">
                                            สามารถลดอุบัติเหตุที่เกิดจากการทำงาน
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="benefitCheckbox" value="11" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label class="form-check-Label ">
                                            สามารถลดเวลาและขั้นตอนการผลิตสินค้าหรือบริการ
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="benefitCheckbox" value="12" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label class="form-check-Label ">
                                            สามารถเพิ่มผลผลิตสินค้าหรือบริการ
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="benefitCheckbox" value="13" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label class="form-check-Label ">
                                            สามารถผลิตสินค้าหรือบริการที่มีคุณภาพ
                                        </Label>
                                    </div>
                                    <div className="form-check mt-3">
                                        <Field type="checkbox" name="benefitCheckbox" value="14" >
                                            {({ field, form }) => (
                                                <Input
                                                    type="checkbox"
                                                    {...field}
                                                />
                                            )}
                                        </Field>
                                        <Label class="form-check-Label ">
                                            อื่นๆ (โปรดระบุ)
                                        </Label>
                                        <Field
                                            name="benefitRemark"
                                            className="rounded-pill"
                                        >
                                            {({ field, form, meta }) => (
                                                <Input
                                                    type="text"
                                                    // disabled={values.benefitCheckbox.includes(element => element === "14")} 
                                                    className="rounded-pill"
                                                    {...field}
                                                />

                                            )}
                                        </Field>
                                    </div>
                                </FormGroup>

                                {/* issue */}
                                <FormGroup className="mt-3">
                                    <Label>ปัญหาอุปสรรค</Label>
                                    <Field
                                        name="issue"
                                    >
                                        {({ field, form }) => (
                                            <Input
                                                type="text"
                                                className="rounded-pill"
                                                {...field}
                                            />
                                        )}

                                    </Field>

                                </FormGroup>

                                {/* remark  */}
                                <FormGroup className="mt-3">
                                    <Label>ข้อคิดเห็นและเสนอแนะ</Label>
                                    <Field
                                        name="remark"
                                    >
                                        {({ field, form }) => (
                                            <Input
                                                type="text"
                                                className="rounded-pill"
                                                {...field}
                                            />
                                        )}

                                    </Field>
                                </FormGroup>

                                <div className="mt-3 d-flex justify-content-center">
                                    {/* <button className="bg-primary text-white w-25 p-2 rounded-pill border-0">ย้อนกลับ</button> */}
                                    <button className="bg-primary text-white w-25 p-2 rounded-pill border-0" type="submit">บันทึก</button>
                                </div>
                            </Form>
                        )
                    }}
                </Formik>

            </div>

        </Container>

    )
}